const users = {
  pageName: 'Usuarios',
  mainTabs: {
    titleInvitations: 'Invitaciones',
    titleExistingUsers: 'Usuarios existentes',
  },
  headerButtons: {
    invite: {
      inviteBtn: 'Invitar',
    },
  },
  toast: {
    error: {
      default: 'Ocurrió un error desconocido.',
      badResponse: 'Respuesta incorrecta del servidor',
      create: {},
      edit: {
        change: 'Contraseña anterior incorrecta',
      },
      unauthorized: 'Operación no autorizada.',
    },
    success: {
      delete: {
        default: 'Usuario eliminado correctamente',
      },
      create: {
        default: 'El usuario ha sido creado correctamente.',
      },
      edit: {
        change: 'Contraseña cambiada',
        default: 'Actualizado por el usuario.',
      },
      reset: {
        default: 'El correo electrónico para restablecer la contraseña se ha enviado correctamente.',
      },
    },
  },

  deleteModal: {
    header: 'Eliminar usuarios',
    body: 'Está a punto de eliminar {{num}} usuarios.',
  },

  create: {
    alreadyExistToast: {
      message: 'Ocurrió un error. El correo electrónico ya existe. Intente con otro correo electrónico.',
    },
    errorRequestToast: {
      message: 'Prohibida No tiene permisos para realizar esta acción. Comuníquese con un administrador.',
    },
    successToast: {
      message: '¡Éxito! El usuario creó correctamente',
    },
    validations: {
      firstName: 'El nombre es obligatorio',
      lastName: 'Apellido es obligatorio',
      phone: {
        invalid: 'El teléfono no es válido',
        required: 'El teléfono es obligatorio',
        length: 'El teléfono debe contener de 6 a 16 dígitos',
      },
      email: {
        required: 'El correo electrónico es obligatorio',
        email: 'Dirección de correo electrónico no válida',
      },
      role: {
        required: 'El rol es obligatorio',
      },
      supplier: {
        required: 'El proveedor es obligatorio',
      },
    },
  },
  select: 'Seleccionar',
  edit: {
    modalRemoveConfirm: {
      header: '¡Advertencia!',
      body: '¿Está seguro de que desea eliminar este usuario? Nota: si está asociado a otros sitios, el usuario será eliminado únicamente del sitio actual.',
      modalRemoveConfirmBtn: 'Eliminar',
    },
    formTabs: {
      informationTab: 'Información',
      notesTab: 'Notas',
      historyTab: 'Historia',
    },
  },

  table: {
    filters: {
      role: 'Función',
    },
    headers: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Telefono',
      role: 'Función',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission require',
    },
  },
  isCompanyAdmin: 'Administrador de la empresa',

  form: {
    header: {
      createUser: {
        title: 'Crear',
      },

      updateUser: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    selectOption: {
      select: 'Seleccionar',
    },
    information: {
      details: {
        header: 'Detalles personales',
        fields: {
          firstName: 'Nombre',
          lastName: 'Apellido',
          name: 'Nombre',
          phone: 'Telefono',
          email: 'Correo electrónico',
          site: 'Sitio',
        },
      },
      roles: {
        header: 'Sitios y funciones',
        fields: {
          role: 'Función',
          site: 'Sitio',
        },
        buttons: {
          addAccess: 'Añadir sitio',
        },
      },
      actions: {
        header: 'Acciones',
        buttons: {
          delete: 'Eliminar',
          resetPassword: 'Restablecer contraseña',
          changePassword: 'Cambiar contraseña',
        },
      },
    },
    valdations: {
      firstName: 'El nombre es obligatorio',
      lastName: 'Apellido es obligatorio',
      phone: 'El teléfono es obligatorio',
      supplier: 'El proveedor es obligatorio',
      role: 'El rol es obligatorio',
      email: {
        required: 'El correo electrónico es obligatorio',
        email: 'Dirección de correo electrónico no válida',
      },
    },
  },
};

export default users;
